import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'bolt', 'Bolt', [["path",{"d":"M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11","key":"svg-0"}]]);